import React from 'react';

import { flagStyles } from '../settings';

const SvgSD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4656px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSD;
